module.exports = __webpack_public_path__ + "img/BELA.7783ff29.svg";